import styled from 'styled-components'

export const PrimaryIcon = styled.i`
  fill: ${({theme}) => theme.colors.primary.base};
`

export const InlinedPrimaryIcon = styled.i`
  height: 24px;
  fill: ${({theme}) => theme.colors.primary.base}; 
`

export const WhiteIcon = styled.i`
  fill: ${props => props.theme.colors.greyscale.white}; 
`

export const SecondaryIcon = styled.i`
  fill: ${({theme}) => theme.colors.secondary.base};
`

export const RedIconRightMargin = styled.i`
  fill: #c00;
  margin-right: 4px;
`
